import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
// import Ingredients from './Ingredients'
// import CookingInstructions from './CookingInstructions'

const RecipeVideo = React.lazy(() => import('./RecipeVideo'))

function RecipeContent({ recipe }) {

  const { ingredients, cookingInstructions } = recipe

  if (!ingredients) {
    ingredients = [{ title: '', ingredient: '' }]
  }
  const groupIngredientsByTitle = (ingredients) => {
    return ingredients?.reduce((acc, item) => {
      if (!acc[item.title]) {
        acc[item.title] = [];
      }
      acc[item.title].push(item.ingredient);
      return acc;
    }, {});
  };

  const groupedData = groupIngredientsByTitle(ingredients);

  // console.log('harmony', recipe)

  return (
    <div className='flex flex-col 1024:flex-row 1024:py-10 1024:gap-x-10'>
      <div className='1024:w-[408px] lg:w-1/3 1024:sticky 1024:left-0 1024:top-[120px] 1024:h-full 1024:flex 1024:flex-col'>
        <div className='1024:border-2 border-solid border-dorot-purple'>
          <div className='pb-0 flex flex-col justify-between h-full'>
            <div className='pt-7.5 pl-7.5 pr-7.5 pb-10 1024:pl-5 1024:pr-7.5 1024:pt-12.5 1024:pb-15 lg:pr-0 lg:pt-10.5 lg:pl-18 lg:pb-20'>
              <h2 className='font-gelica text-_2848 1024:text-_4032 lg:text-_3632 font-bold text-dorot-purple'>Ingredients:</h2>

              <hr className='hidden 1024:block 1024:mt-3.5 lg:my-6 lg:w-[70%] border-dorot-purple border-2 border-solid'></hr>

              <ul className='1024:pt-10 lg:pt-0 lg:w-[80%]'>

                {Object.keys(groupedData).map((title) => (
                  <li key={title}>
                    {title !== 'Ingredients' && <h2 className='font-gelica text-_3232 font-bold text-dorot-purple mt-6'>{title}</h2>}
                    <ul className=''>
                      {groupedData[title].map((ingredient, index) => (
                        <div className='flex gap-4 items-baseline my-6 last:mb-0' key={index}>
                          <StaticImage src="../../images/IngredientDot.webp" alt="ingredient" className='!w-[15px] !h-[15px] flex-none'></StaticImage>
                          <li key={index} className="font-goldplay text-_1625 text-semibold 1024:text-_2032 1024:font-bold text-dorot-purple [&_a]:hover:underline [&_a]:text-dorot-filter-pink" dangerouslySetInnerHTML={{ __html: ingredient }}></li>
                        </div>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>

            </div>
          </div>
        </div>
      </div>

      <div className='1024:w-[616px] lg:w-2/3 bg-white'>
        <div className='pb-0'>
          {recipe.recipeVideo?.mediaItemUrl && (
            <React.Suspense fallback={<div className='w-full bg-black' style={{ aspectRatio: '16 / 9' }} />}>
              <RecipeVideo video={recipe.recipeVideo} />
            </React.Suspense>
          )}
          <div className='pl-7.5 pr-7.5 pt-10 pb-10 1024:pt-12.5 1024:pl-0 1024:pr-10.5 lg:pt-10.5 lg:pl-[67px] lg:pb-20 lg:w-[777px]'>
            <h2 className='font-gelica text-_2848 1024:text-_3648 font-semibold text-dorot-purple'>Cooking Instructions:</h2>
            <hr className='lg:my-6 border-dorot-purple border-2 border-solid'></hr>
            {cookingInstructions.map((instruction, index) => (
              <div className='flex gap-4 items-baseline my-7.5 1024:my-9 lg:my-6 last:mb-0' key={index}>
                <div className="w-10 h-10 border-2 border-solid border-dorot-purple lg:border-none lg:bg-dorot-cooking-instructions text-dorot-purple lg:text-white rounded-full flex items-center justify-center flex-none">{index + 1}</div>
                <span key={index} className="font-goldplay font-semibold text-_1625 1024:text-_2032 text-dorot-purple">{instruction.instructions}</span>
              </div>
            ))}
          </div>
          {recipe?.recipeDetails && (
            <div className='pl-7.5 pr-7.5 pt-10 pb-10 1024:pt-12.5 1024:pl-0 1024:pr-10.5 lg:pt-10.5 lg:pl-[67px] lg:pb-20 lg:w-[777px]'>
              <h2 className='font-gelica text-_2848 1024:text-_3648 font-semibold text-dorot-purple'>Recipe Details:</h2>
              <hr className='lg:my-6 border-dorot-purple border-2 border-solid'></hr>
              <div
                id="recipeDetails"
                className="text-dorot-purple [&_p]:text-_2025 [&_ul>li]:text-_2025 [&_ol>li]:text-_2025 [&_p]:font-goldplay [&_ol>li]:font-goldplay [&_ul>li]:font-goldplay [&_p]:font-semibold [&_p]:mb-11 [&_h2]:text-_2432 [&_h2]:font-gelica [&_h2]:font-bold [&_h2]:mb-5 [&_h2]:scroll-mt-36 [&_h3]:text-_2025 [&_h3]:font-gelica [&_h3]:font-semibold [&_h3]:mb-2 [&_h4]:text-_2025 [&_h4]:font-gelica [&_h4]:font-bold [&_ul]:pl-10 [&_ol]:pl-10 [&_ul]:mb-11 [&_ol]:mb-11 [&_figure>table]:mb-11 [&_figure>table]:table-auto [&_figure>table_td]:px-4 [&_figure>table_td]:py-2 [&_figure>table]:border-collapse [&_figure>table]:border-spacing-2 [&_figure>table]:border-2 [&_figure>table]:border-solid [&_figure>table]:border-dorot-purple [&_figure>table_tr:first-child]:bg-dorot-purple [&_figure>table_tr:first-child]:text-white [&_a>span]:underline [&_ul]:list-disc [&_ol]:list-disc"
                dangerouslySetInnerHTML={{ __html: recipe?.recipeDetails }}
              ></div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RecipeContent
